export const TRIAL_PAGES_V1C = 'v1c';
